export default "__VITE_ASSET__BawmwLGM__"